import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSpaceEmployee on SpaceEmployee {
    code
    description
    id
    jobTitleId
    name
    organization {
      entityId
      recordId
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceEmployeeFragment,
  ents.extra.space.Employee
>({
  code: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Employee.Id.isId,
  ),
  jobTitleId: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      ents.extra.space.JobTitle.Id.assertIsId,
    ),
  ),
  name: transformers.PASS_THROUGH,
  organization: graphql.transformers.OUT.nonNull(
    graphql.transformers.OUT.object({
      entityId: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        ents.core.dms.models.Entity.Id.assertIsId,
      ),
      recordId: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        ents.extra.space.Organization.Id.assertIsId,
      ),
    }),
  ),
})
